<template>
  <div class="container video-section" data-aos="fade-up" v-if="hasData">
    <div class="section-title">
      <h2>{{ getText(videoSection.title_zh, videoSection.title_en) }}</h2>
      <p>{{ getText(videoSection.subtitle_zh, videoSection.subtitle_en) }}</p>
    </div>

    <div class="row video-row">
      <div class="col-lg-6">
        <div
          class="member d-flex align-items-start"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          <div class="post w-100 video-card">
            <h4>
              {{
                getText(
                  videoSection.video1_title_zh,
                  videoSection.video1_title_en,
                )
              }}
            </h4>

            <div v-if="!isShowMore" class="text-left">
              <p>
                {{
                  getText(
                    videoSection.video1_shortDesc_zh,
                    videoSection.video1_shortDesc_en,
                  )
                }}
              </p>
              <button class="read" type="button" @click="isShowMore = true">
                {{
                  getText(videoSection.readMore_zh, videoSection.readMore_en)
                }}
              </button>
            </div>

            <div v-else class="text-left">
              <p>
                {{
                  getText(
                    videoSection.video1_fullDesc1_zh,
                    videoSection.video1_fullDesc1_en,
                  )
                }}
                <br /><br />
                {{
                  getText(
                    videoSection.video1_fullDesc2_zh,
                    videoSection.video1_fullDesc2_en,
                  )
                }}
                <br /><br />
                {{
                  getText(
                    videoSection.video1_fullDesc3_zh,
                    videoSection.video1_fullDesc3_en,
                  )
                }}
              </p>
              <button class="read" type="button" @click="isShowMore = false">
                {{
                  getText(videoSection.readLess_zh, videoSection.readLess_en)
                }}
              </button>
            </div>

            <div class="embed-container">
              <iframe
                :src="
                  getEmbedUrl(
                    videoSection.video1_url,
                    'https://www.youtube.com/embed/P4t1U_8fKXk',
                  )
                "
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                title="HMH Into Reading"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mt-4 mt-lg-0">
        <div
          class="member d-flex align-items-start"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div class="post w-100 video-card">
            <h4>
              {{
                getText(
                  videoSection.video2_title_zh,
                  videoSection.video2_title_en,
                )
              }}
            </h4>

            <div v-if="!isShowMore2" class="text-left">
              <p>
                {{
                  getText(
                    videoSection.video2_shortDesc_zh,
                    videoSection.video2_shortDesc_en,
                  )
                }}
              </p>
              <button class="read" type="button" @click="isShowMore2 = true">
                {{
                  getText(videoSection.readMore_zh, videoSection.readMore_en)
                }}
              </button>
            </div>

            <div v-else class="text-left">
              <p>
                {{
                  getText(
                    videoSection.video2_fullDesc_zh,
                    videoSection.video2_fullDesc_en,
                  )
                }}
              </p>
              <button class="read" type="button" @click="isShowMore2 = false">
                {{
                  getText(videoSection.readLess_zh, videoSection.readLess_en)
                }}
              </button>
            </div>

            <div class="embed-container">
              <iframe
                :src="
                  getEmbedUrl(
                    videoSection.video2_url,
                    'https://www.youtube.com/embed/RHayHIvA6NA',
                  )
                "
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                title="HMH Into Math"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="container" data-aos="fade-up">
    <div class="section-title">
      <h2 v-if="isLoading">Loading...</h2>
      <template v-else>
        <h2>影片資料暫時無法載入</h2>
        <p>請稍後重新整理頁面。</p>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";

export default {
  name: "VeDio",
  setup() {
    const videoSection = ref({});
    const isShowMore = ref(false);
    const isShowMore2 = ref(false);

    const { proxy } = getCurrentInstance();

    const currentLang = computed(() => {
      const locale = proxy?.$i18n?.locale;
      return typeof locale === "object" && locale !== null
        ? locale.value
        : locale;
    });

    const hasData = computed(() => {
      return Object.keys(videoSection.value).length > 0;
    });

    const getText = (zh, en) => {
      return currentLang.value === "zh" || currentLang.value === "zh-TW"
        ? zh || en || ""
        : en || zh || "";
    };

    const getEmbedUrl = (url, fallback) => {
      if (!url) return fallback;

      if (url.includes("youtube.com/embed/")) return url;

      if (url.includes("watch?v=")) {
        const videoId = url.split("watch?v=")[1]?.split("&")[0];
        return videoId ? `https://www.youtube.com/embed/${videoId}` : fallback;
      }

      if (url.includes("youtu.be/")) {
        const videoId = url.split("youtu.be/")[1]?.split("?")[0];
        return videoId ? `https://www.youtube.com/embed/${videoId}` : fallback;
      }

      return url;
    };

    const isLoading = ref(true);

    const fetchData = async () => {
      try {
        // VeDio Google Sheet
        const sheetID = "1iZdU4mAgqfhS_ob-9yjGnRPy-hgw7PH_uWiAkEEnfjA";
        const sheetName = "工作表1";
        const apiKey = "AIzaSyD21a6U3dc4wpee6BCu4D-pxnPff9QSW4w";

        const range = encodeURIComponent(`${sheetName}!A:C`);
        const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/${range}?alt=json&key=${apiKey}`;
        const response = await fetch(url);

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Google Sheets API ${response.status}: ${errorText}`);
        }

        const data = await response.json();
        formatArrayDataToObject(data.values || []);
      } catch (error) {
        console.error("讀取影片資料失敗：", error);
        videoSection.value = {};
      } finally {
        isLoading.value = false;
      }
    };

    // Sheet 格式：A=key、B=en、C=zh-TW，每一列是一個欄位。
    // 將 Sheet 的 videoSection.video01.title 轉成原本 template 使用的欄位名稱。
    const formatArrayDataToObject = (dataList) => {
      if (!Array.isArray(dataList) || dataList.length < 2) return;

      const headers = dataList[0].map((item) => String(item || "").trim());
      const keyIndex = headers.indexOf("key");
      const enIndex = headers.indexOf("en");
      const zhIndex = headers.findIndex(
        (item) => item === "zh-TW" || item === "zh",
      );

      if (keyIndex === -1 || enIndex === -1 || zhIndex === -1) {
        throw new Error("影片 Sheet 欄位必須包含 key、en、zh-TW");
      }

      const fieldMap = {
        "videoSection.title": "title",
        "videoSection.subtitle": "subtitle",
        "videoSection.readMore": "readMore",
        "videoSection.readLess": "readLess",
        "videoSection.video01.title": "video1_title",
        "videoSection.video1.title": "video1_title",
        "videoSection.video01.shortDesc": "video1_shortDesc",
        "videoSection.video1.shortDesc": "video1_shortDesc",
        "videoSection.video01.fullDesc1": "video1_fullDesc1",
        "videoSection.video1.fullDesc1": "video1_fullDesc1",
        "videoSection.video01.fullDesc2": "video1_fullDesc2",
        "videoSection.video1.fullDesc2": "video1_fullDesc2",
        "videoSection.video01.fullDesc3": "video1_fullDesc3",
        "videoSection.video1.fullDesc3": "video1_fullDesc3",
        "videoSection.video01.url": "video1_url",
        "videoSection.video1.url": "video1_url",
        "videoSection.video02.title": "video2_title",
        "videoSection.video2.title": "video2_title",
        "videoSection.video02.shortDesc": "video2_shortDesc",
        "videoSection.video2.shortDesc": "video2_shortDesc",
        "videoSection.video02.fullDesc": "video2_fullDesc",
        "videoSection.video2.fullDesc": "video2_fullDesc",
        "videoSection.video02.url": "video2_url",
        "videoSection.video2.url": "video2_url",
      };

      const result = {};

      dataList.slice(1).forEach((row) => {
        const sheetKey = String(row[keyIndex] || "").trim();
        const field = fieldMap[sheetKey];
        if (!field) return;

        result[`${field}_en`] = row[enIndex] || "";
        result[`${field}_zh`] = row[zhIndex] || "";
      });

      // URL 不分語系；若 Sheet 未提供，template 會使用既有 YouTube fallback。
      result.video1_url = result.video1_url_en || result.video1_url_zh || "";
      result.video2_url = result.video2_url_en || result.video2_url_zh || "";

      videoSection.value = result;
    };

    onMounted(() => {
      fetchData();
    });

    return {
      videoSection,
      isShowMore,
      isShowMore2,
      getText,
      getEmbedUrl,
      hasData,
      isLoading,
    };
  },
};
</script>

<style scoped>
.video-section {
  background: transparent;
  padding-top: 60px;
  padding-bottom: 70px;
}

.video-section .section-title {
  margin-bottom: 46px;
}

.video-row {
  row-gap: 48px;
}

.video-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.video-card h4 {
  min-height: 58px;
  margin: 0 0 16px;
  color: #2f5688;
  font-size: 20px;
  line-height: 1.45;
  font-weight: 700;
}

.text-left {
  text-align: left;
  margin-bottom: 22px;
}

.text-left p {
  margin-bottom: 14px;
  line-height: 1.75;
}

.post {
  width: 100%;
}

.read {
  margin-top: 6px;
  padding: 9px 20px;
  border: none;
  border-radius: 999px;
  background: #53b7e8;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
}

.read:hover {
  opacity: 0.9;
}

.embed-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  margin-top: 8px;
  border-radius: 8px;
}

.embed-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* 兩張影片卡片 */
.video-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 28px;
  height: 100%;
  box-shadow: 0 4px 18px rgba(30, 75, 120, 0.08);
}

/* 卡片標題 */
.video-card h4 {
  margin-bottom: 22px;
  line-height: 1.6;
}

/* 介紹文字 */
.video-card .text-left {
  margin-bottom: 22px;
}

/* 閱讀更多按鈕 */
.video-card .read {
  margin-top: 12px;
  margin-bottom: 8px;
}

/* 影片 */
.video-card .embed-container {
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
}

/* 左右兩張卡片拉開 */
.video-row {
  margin-top: 45px;
  row-gap: 30px;
}

/* 手機 */

@media (max-width: 991.98px) {
  .video-section {
    padding: 20px;
    padding-bottom: 64px;
  }

  .video-row {
    margin-top: 30px;
  }

  .video-section .section-title {
    margin-bottom: 34px;
  }

  .video-card h4 {
    min-height: auto;
  }
}

@media (max-width: 575.98px) {
  .video-section {
    padding-bottom: 52px;
  }

  .video-row {
    row-gap: 40px;
  }

  .video-card h4 {
    font-size: 18px;
  }
}
</style>
